/**
 * Checks if we're in embed mode by examining the URL path
 *
 * Returns true if the application's pathname contains '/embed'
 * Checks only the Iframe's pathname (if embedded in another page), not the parent's
 */
export function isInEmbedMode(): boolean {
    // Check if the URL path contains '/embed'
    return window.location.pathname.includes('/embed')
}
